module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whiteWrapper"
  }, [_vm._l((_vm.headerTexts), function(headerText) {
    return _c('p', [_vm._v("\n    " + _vm._s(headerText) + "\n  ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.to')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": _vm.isEmailInput ? true : false,
      "allow-create": _vm.isEmailInput ? true : false,
      "placeholder": "Select Recipient",
      "multiple": true
    },
    model: {
      value: (_vm.emailTo),
      callback: function($$v) {
        _vm.emailTo = $$v
      },
      expression: "emailTo"
    }
  }, _vm._l((_vm.contactOptions), function(contact) {
    return _c('el-option', {
      key: contact.id,
      attrs: {
        "label": contact.name,
        "value": contact.email
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" CC:")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filter-method": _vm.ccOptionFilter,
      "filterable": true,
      "allow-create": true,
      "placeholder": "Select email cc",
      "multiple": true,
      "popper-class": "ccEmail hidden"
    },
    model: {
      value: (_vm.emailcc),
      callback: function($$v) {
        _vm.emailcc = $$v
      },
      expression: "emailcc"
    }
  }, _vm._l((_vm.ccOptions), function(cc) {
    return _c('el-option', {
      key: cc.id,
      attrs: {
        "label": cc.email,
        "value": cc.email
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.subject')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-input', {
    attrs: {
      "name": "subject"
    },
    model: {
      value: (_vm.previewSubject),
      callback: function($$v) {
        _vm.previewSubject = $$v
      },
      expression: "previewSubject"
    }
  })], 1)])]), _vm._v(" "), (_vm.server) ? _c('div', [_c('file-pond', {
    ref: "pond",
    attrs: {
      "name": "pdfAttachment",
      "label-idle": "Drag & Drop your files or <span class=\"filepond--label-action\"> Browse </span><br> <b>Pdf attachment only with maximum 2 files upload</b>",
      "allow-multiple": "true",
      "max-files": "3",
      "maxFileSize": "500kb",
      "accepted-file-types": "application/pdf",
      "server": _vm.attachmentServer,
      "files": _vm.attachmentInit
    }
  }), _vm._v(" "), _vm._m(0)], 1) : _c('p', [_vm._v(_vm._s(_vm.$t('static.bills.edit.attachment')) + ":\n    "), _vm._l((_vm.attachments), function(attachment) {
    return _c('a', {
      attrs: {
        "loading": _vm.modalButtonLoading,
        "title": attachment.title,
        "role": "button"
      },
      on: {
        "click": attachment.action
      }
    }, [_vm._v("\n        " + _vm._s(attachment.attachmentName) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "el-textarea margin-b-10"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.messageBody')) + ":")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previewMessage),
      expression: "previewMessage"
    }],
    staticClass: "el-textarea__inner",
    attrs: {
      "rows": "10",
      "name": "message"
    },
    domProps: {
      "value": (_vm.previewMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.previewMessage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "el-textarea"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.notes')) + ":")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previewNotes),
      expression: "previewNotes"
    }],
    staticClass: "el-textarea__inner",
    attrs: {
      "rows": "3",
      "name": "note"
    },
    domProps: {
      "value": (_vm.previewNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.previewNotes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
  }, _vm._l((_vm.buttons), function(button) {
    return _c('el-button', {
      attrs: {
        "loading": _vm.modalButtonLoading
      },
      on: {
        "click": button.action
      }
    }, [_vm._v("\n        " + _vm._s(button.name) + "\n    ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "full-w flex wrap"
  }, _vm._l((_vm.links), function(link) {
    return _c('a', {
      attrs: {
        "loading": _vm.modalButtonLoading,
        "title": link.title,
        "role": "button"
      },
      on: {
        "click": link.action
      }
    }, [_vm._v("\n        " + _vm._s(link.name) + "\n    ")])
  }), 0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errors filepond"
  }, [_c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58f94deb","hasScoped":false}!./src/app/components/previewMessage/previewMessage.html
// module id = 3020
// module chunks = 1